import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, provide, watch, onBeforeUnmount, onMounted } from 'vue'
import $ from 'jquery'
import { useRoute } from 'vue-router'
import { Theme } from './utils/theme'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const internalClass = ref('')
const themeClass = ref(Theme.DARK)
const pageThemes = ref()

function setAppClass(className: string) {
  internalClass.value = className
}

function setThemeClass(className: Theme) {
  if (themeClass.value) {
    $('body').removeClass([internalBodyClass.value, themeClass.value])
  }
  themeClass.value = className
  if (className) {
    $('body').addClass([internalBodyClass.value, themeClass.value])
  }
}

const internalBodyClass = ref('')
function setBodyClass(className: string) {
  if (internalBodyClass.value) {
    $('body').removeClass([internalBodyClass.value, themeClass.value])
  }
  internalBodyClass.value = className
  if (className) {
    $('body').addClass([internalBodyClass.value, themeClass.value])
  }
}

provide('setAppClass', setAppClass)
provide('setThemeClass', setThemeClass)
provide('setBodyClass', setBodyClass)

// Site theme > page theme
function setPageTheme(pageTheme: string) {
  pageThemes.value = pageTheme
  localStorage.setItem('appThemeColor', pageTheme)
  $(document.documentElement).attr('page-theme', pageTheme)
}

provide('setPageTheme', setPageTheme)
provide('pageThemes', pageThemes)

watch(
  () => route.fullPath,
  () => {
    setAppClass('')
    setBodyClass('')
  }
)
onMounted(() => {
  const theme = localStorage.getItem('appThemeColor')
  if (theme) {
    setPageTheme(theme)
  }

  if ('scrollRestoration' in history) {
    // 禁用浏览器的自动滚动恢复
    history.scrollRestoration = 'manual'
  }
})

onBeforeUnmount(() => {
  localStorage.removeItem('appThemeColor')
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    id: "appInternal",
    class: _normalizeClass(internalClass.value)
  }, [
    _createVNode(_component_router_view)
  ], 2))
}
}

})